import { useCallback, useRef } from "react";
import { announce } from "../helper/a11yAnnouncements";

export const REGISTRATION_STEP_TITLE_PROPS = {
  tabIndex: -1,
};

export const REGISTRATION_NAV_DIRECTION_KEY = "registrationNavDirection";

export const REGISTRATION_NAVBAR_STEP_LABEL_ID =
  "registration-navbar-step-label";

export const markRegistrationNavigatingBack = () => {
  try {
    sessionStorage.setItem(REGISTRATION_NAV_DIRECTION_KEY, "back");
  } catch {
    // Ignore storage errors; title focus is still applied.
  }
};

/**
 * Speak the current step once through the live region when announcements are on.
 */
export const announceRegistrationStep = (message) => {
  announce(message, "important");
};

/**
 * After Next or Back, focus the step heading in the page body.
 * Tab then moves to the first field or button on the page, not the navbar.
 */
export function useRegistrationStepFocus() {
  const didFocusRef = useRef(false);

  return useCallback((node) => {
    if (!node || didFocusRef.current) {
      return;
    }
    if (document.querySelector('[aria-modal="true"]')) {
      return;
    }

    window.requestAnimationFrame(() => {
      if (didFocusRef.current) {
        return;
      }
      didFocusRef.current = true;

      try {
        sessionStorage.removeItem(REGISTRATION_NAV_DIRECTION_KEY);
      } catch {
        // Ignore storage errors.
      }

      node.focus({ preventScroll: false });
    });
  }, []);
}
